import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import Controller from '@ember/controller';
import type IntlService from 'ember-intl/services/intl';
import { BALANCES_URL } from '@banking/ui/utils/constants';
import type RouterService from '@ember/routing/router-service';
import { replace } from '@square/dashboard-utilities/utils/window';

export default class InManualReviewController extends Controller {
  @service intl!: IntlService;
  @service router!: RouterService;

  @action
  onNextButtonClick() {
    replace(BALANCES_URL);
  }
}
